import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

export const showToast = (type, message) => {
    if (type==="error") {
        toast.error(message, {
            position: "bottom-right"
        }); 
    } else if (type==="success") {
        toast.success(message, {
            position: "bottom-right"
        });
    } else if (type==="warning") {
        toast.warning(message, {
            position: "bottom-right"
        });
    } else if (type==="info") {
        toast.info(message, {
            position: "bottom-right"
        });
    }
}
export function parseJwt(token) {
    if (!token) { return }
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64));
}
export const getLogo = () => {
    const client = process.env.REACT_APP_CLIENT_NAME;
    return <img alt="logo" src={require(`../assets/images/${client}/logo.png`)} />
}

export const getImage = (name) => {
    const client = process.env.REACT_APP_CLIENT_NAME;
    return <img alt="logo" src={require(`../assets/images/${client}/${name}`)} />
}

export const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result.split(',')[1]);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob); 
    });
};